import { render, staticRenderFns } from "./SplashLoader.vue?vue&type=template&id=b37fd106&scoped=true&"
import script from "./SplashLoader.vue?vue&type=script&lang=ts&"
export * from "./SplashLoader.vue?vue&type=script&lang=ts&"
import style0 from "./SplashLoader.vue?vue&type=style&index=0&id=b37fd106&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b37fd106",
  null
  
)

export default component.exports